export const languageElements = {
  items: {
    'required': {
      hu: 'Kérem adja meg!',
      de: 'Bitte angeben!',
      en: 'Please enter!',
    },
    'idRequired': {
      hu: 'Kérem válasszon a listából!',
      de: 'Bitte von der Liste wählen!',
      en: 'Please select from the list.',
    },
    'validContainerNr': {
      hu: 'Kérem adja meg a konténerszámot "ABCU1234567" alakban.',
      de: 'Bitte geben Sie die Containernummer in der Form „ABCU1234567“ ein.',
      en: 'Please enter the container number in the form "ABCU1234567".',
    },
    'validContainerNr-pattern-2': {
      hu: 'Kérem adja meg a konténerszámot "ABCU 123456-1" alakban.',
      de: 'Bitte geben Sie die Containernummer in der Form „ABCU 123456-1“ ein.',
      en: 'Please enter the container number in the form "ABCU 123456-1".',
    },
    'validEmail': {
      hu: 'Adjon meg valódi email címet!',
      de: 'Bitte echte E-Mail-Adresse eingeben!',
      en: 'Please enter a valid email.',
    },
    'validWagonNr': {
      hu: 'Hibás vagonszám',
      de: 'Fehlerhafte Waggonsnummer',
      en: 'Incorrect wagonnumber',
    },
    'validStationsCode': {
      hu: 'Hibás állomás kód',
      de: 'Falscher Stationscode',
      en: 'Incorrect station code',
    },
    'float': {
      hu: 'Kérem adjon meg pozitív számot számot maximum 3 tizedesjeggyel.',
      de: 'Bitte geben Sie eine positive Zahl mit maximal 3 Nachkommastellen ein.',
      en: 'Please enter a positive number with a maximum of 3 decimal places.',
    },
    'float2': {
      hu: 'Kérem adjon meg pozitív számot számot maximum 2 tizedesjeggyel.',
      de: 'Bitte geben Sie eine positive Zahl mit maximal 2 Nachkommastellen ein.',
      en: 'Please enter a positive number with a maximum of 2 decimal places.',
    },
    'float4': {
      hu: 'Kérem adjon meg pozitív számot számot maximum 4 tizedesjeggyel.',
      de: 'Bitte geben Sie eine positive Zahl mit maximal 4 Nachkommastellen ein.',
      en: 'Please enter a positive number with a maximum of 4 decimal places.',
    },
    'int': {
      hu: 'Kérem adjon meg pozitív egész számot.',
      de: 'Bitte geben Sie eine positive Ganzzahl.',
      en: 'Please enter a positive integer.',
    },
    'not_0': {
      hu: 'Kérem adjon meg 0-tól különböző számot.',
      de: 'Bitte geben Sie eine andere Zahl als 0 ein.',
      en: 'Please enter a number other than 0.',
    },
    'mustAccept': {
      hu: 'Kérem fogadja el a feltételeket.',
      de: 'Bitte akzeptieren Sie die Bedingungen.',
      en: 'Please accept the conditions.',
    },



    'ETA_later_than_ETD': {
      hu: 'ETA > ETD',
      de: 'ETA > ETD',
      en: 'ETA > ETD',
    },

    'ATA_later_than_ATD': {
      hu: 'ATA > ATD',
      de: 'ATA > ATD',
      en: 'ATA > ATD',
    },
    
    'freightPrice_less_than_freightCost': {
      hu: 'A fuvarköltség magasabb, mint a fuvardíj.',
      de: 'Frachtkosten sind grösser als der Frachtpreis.',
      en: 'The freightcost is higher than the freightprice.',
    },
  },
};
